"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactRow = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _stack = require("./stack");
var _excluded = ["children", "divider", "justifyContent", "justify", "spacing"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DEFAULT_JUSTIFY = 'flex-start';
var DEFAULT_SPACING = 1;
var CompactRow = exports.CompactRow = function CompactRow(_ref) {
  var children = _ref.children,
    divider = _ref.divider,
    justifyContent = _ref.justifyContent,
    justify = _ref.justify,
    spacing = _ref.spacing,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_stack.Stack, (0, _extends2["default"])({
    divider: divider,
    spacing: spacing !== null && spacing !== void 0 ? spacing : DEFAULT_SPACING,
    justifyContent: justifyContent || justify || DEFAULT_JUSTIFY,
    alignItems: "center"
  }, rest, {
    direction: "row"
  }), children);
};